export default "__VITE_ASSET__CYUKe4Wx__"